import { AppInputProps } from 'components/app-input';
import { useTranslate } from 'hooks/use-translate';
import { useCallback } from 'react';
import { ControllerFieldState, ControllerRenderProps, UseFormStateReturn } from 'react-hook-form';
import { decorateAfter, fieldToLabelKey } from 'utils/other';

interface Options {
  field: ControllerRenderProps<any, any>;
  fieldState: ControllerFieldState;
  formState: UseFormStateReturn<any>;
}

type Props = Omit<AppInputProps, 'onError' | 'ref'>;

export const useFormInputProps = (props?: Partial<Props>) => {
  const { t } = useTranslate();
  return useCallback(
    (options: Options) => {
      const { field, fieldState } = options;
      const helperText = fieldState.error?.message ? t(fieldState.error.message) : '';
      return {
        ...field,
        ...props,
        onChange: decorateAfter(field.onChange, props?.onChange),
        onBlur: decorateAfter(field.onBlur, props?.onBlur),
        helperText,
        error: Boolean(fieldState.error),
        fullWidth: true,
        label: t(fieldToLabelKey(field.name)),
      };
    },
    [t, props],
  );
};
